function escapar(valor) {
  return String(valor == null ? '' : valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export default function termoLiberacaoPagamento({ nome, documento, nomeProjeto, nomeModulo }) {
  return "<div style='font-size: 18px; text-align: left;'>" +
    "  <div style='text-align: center;'><strong>Termo de Consentimento para Liberação Direta de Pagamento</strong></div>" +
    "  <br />" +
    "  Eu, <strong>" + escapar(nome) + "</strong>, portador(a) do documento nº <strong>" + escapar(documento) + "</strong>," +
    "  na qualidade de Coordenador/Vice Coordenador do projeto <strong>" + escapar(nomeProjeto) + "</strong>," +
    "  autorizo a Fundação de Apoio à Universidade de São Paulo (FUSP) a realizar a" +
    "  liberação direta de Solicitação de Pagamento (SP) para as compras realizadas por meio" +
    "  da plataforma de <strong>" + escapar(nomeModulo) + "</strong>, sem a necessidade de minha aprovação posterior." +
    "  <br /><br />" +
    "  Entende-se que a aprovação prévia da Solicitação de Compra já serve como" +
    "  consentimento para a liberação do respectivo pagamento, desde que o valor final" +
    "  (incluindo produto e frete) esteja em conformidade com o saldo disponível e o percentual" +
    "  de variação de preço previamente estipulado para o(s) item(ns) no Projeto." +
    "  <br /><br />" +
    "  Assim, confirmo que estou ciente e de acordo com esta modalidade de procedimento," +
    "  que visa otimizar os processos de pagamento do projeto." +
    "  <br /><br />" +
    "</div>";
}



// WEBPACK FOOTER //
// ./FrontEnd/js/termo-liberacao-pagamento.js